import React from 'react';
import './WalletInfo.css';
import Claim from '../Vesting';
import { useWeb3ModalAccount } from '@web3modal/ethers/react';
import { useEffect, useState } from 'react';
import { formatUnits } from 'ethers';

const PresaleHistory = ({ vContract }) => {

  const {address, isConnected} = useWeb3ModalAccount();

  const [tokenBalance, setTokenBalance] = useState(0);
  const [claimed, setClaimed] = useState(0);
  const [claimable, setClaimable] = useState(0);
  const [isClaim, setIsClaim] = useState(false);

  useEffect(() => {
      if(vContract && isConnected) {
        getData();
      }

  }, [vContract])

  const getData = async() => {
    try {
      const result = await vContract.vestings(address);
      const claimable = await vContract.getClaimableTokens(address);

      if(formatUnits(claimable) > 0) {
        setIsClaim(true);
      }

      setTokenBalance(Number(formatUnits(result[0])).toFixed(2));
      setClaimed(Number(formatUnits(result[1])).toFixed(2));
      setClaimable(Number(formatUnits(claimable)).toFixed(2));
    } catch (error) {
      console.log(error);
    }
  }

    return (
        <section className="presale-overview-section">
          {/* Left Box: Wallet Information */}
          <div className="left-box">
            <h2>Wallet Info</h2>
            <div className="wallet-info">
              <div className="wallet-info-row">
                <span className="wallet-info-label">Wallet:</span>
                <span className="wallet-info-value">{isConnected ? (address.slice(0,4) + "..." + address.slice(38,42)) : ""}</span>
              </div>
              <div className="wallet-info-row">
                <span className="wallet-info-label">Purchased:</span>
                <span className="wallet-info-value">{tokenBalance}</span>
              </div>
              <div className="wallet-info-row">
                <span className="wallet-info-label">Launch Value:</span>
                <span className="wallet-info-value">${(tokenBalance * 0.1).toFixed(2)}</span>
              </div>
              <div className="wallet-info-row">
                <span className="wallet-info-label">Claimed:</span>
                <span className="wallet-info-value">{claimed}</span>
              </div>
            </div>
          </div>
    
          {/* Right Box: Presale Transactions Table */}
          <div className="right-box">
            <h2>Claim your tokens</h2>
            <Claim claimAmount={claimable} claimAvailable={isClaim} vContract={vContract}></Claim>
          </div>
        </section>
      );
};

export default PresaleHistory;
